import { headers, dataTypes } from 'constants/tableColumns';

export const detailedViewTable = [
    {
        i: 1,
        w: '6.6%',
        th: headers.creationMonth,
        prop: 'creationMonth',
        type: dataTypes.string
    },
    {
        i: 2,
        w: '7.9%',
        th: headers.rmRegion,
        prop: 'rmRegion',
        type: dataTypes.string
    },
    {
        i: 3,
        w: '7.9%',
        th: headers.rmGroup,
        prop: 'rmGroup',
        type: dataTypes.string
    },
    {
        i: 4,
        w: '6.6%',
        th: headers.rm,
        prop: 'rm',
        type: dataTypes.string
    },
    {
        i: 5,
        w: '6.6%',
        th: headers.s1Rank,
        prop: 's1Rank',
        type: dataTypes.number
    },
    {
        i: 6,
        w: '6.35%',
        th: headers.s1Score,
        prop: 's1Score',
        type: dataTypes.number
    },
    {
        i: 7,
        w: '6.35%',
        th: headers.s2Rank,
        prop: 's2Rank',
        type: dataTypes.number
    },
    {
        i: 8,
        w: '6.35%',
        th: headers.s2Score,
        prop: 's2Score',
        type: dataTypes.number
    },
    {
        i: 9,
        w: '6.35%',
        th: headers.s3Rank,
        prop: 's3Rank',
        type: dataTypes.number
    },
    {
        i: 10,
        w: '6.35%',
        th: headers.s3Score,
        prop: 's3Score',
        type: dataTypes.number
    },
    {
        i: 11,
        w: '6.35%',
        th: headers.s4Rank,
        prop: 's4Rank',
        type: dataTypes.number
    },
    {
        i: 12,
        w: '6.35%',
        th: headers.s4Score,
        prop: 's4Score',
        type: dataTypes.number
    },
    {
        i: 13,
        w: '8.6%',
        th: headers.correlationScore,
        prop: 'correlationScore',
        type: dataTypes.number
    },
    {
        i: 14,
        w: '6.6%',
        th: headers.totalScore,
        prop: 'totalScore',
        type: dataTypes.number
    }
];
